import { useMemo } from "react"

import { useSessionBookingsQuery } from "../../../networking/sessions/queries"

export const useNoShowSessionsCount = () => {
  const { data: bookings } = useSessionBookingsQuery()
  const noShowCount = useMemo(
    () => bookings?.filter((booking) => booking.marked_no_show).length,
    [bookings]
  )
  return noShowCount || 0
}
